import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    console.log("Sidebar controller connecté !");
    
    // Lier une seule fois les méthodes pour pouvoir les ajouter / retirer proprement
    this.boundCloseOnEscape = this.closeOnEscape.bind(this);
    // this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this);
    
    document.addEventListener("keydown", this.boundCloseOnEscape);
    // document.addEventListener("click", this.boundCloseOnClickOutside);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundCloseOnEscape);
    // document.removeEventListener("click", this.boundCloseOnClickOutside);
  }

  toggle(event) {
    event.preventDefault(); 
    event.stopImmediatePropagation(); 
    let closestTabContent = event.target.closest(".tabcontent");

    if (!closestTabContent) {
      console.error("Aucun élément .tabcontent trouvé !");
      return;
    }

    console.log("ID du tabcontent trouvé :", closestTabContent.id);

    let sidebar = closestTabContent.querySelector(".fx-hm-sidebar");

    if (!sidebar) {
      console.error("Aucun sidebar trouvé dans ce tabcontent !");
      return;
    }

    let isOpened = sidebar.style.width && sidebar.style.width !== "0px";

    if (isOpened) {
      this.closeNav(sidebar);
    } else {
      this.openNav(sidebar);
    }
  }

  openNav(sidebar) {
    this.sidebar = sidebar; // Stocke la référence au sidebar ouvert
    this.isOpened = true; // Indique que le sidebar est ouvert
    sidebar.style.display = "block";
    sidebar.style.opacity = "0"; // Début de l'effet de fondu
    sidebar.style.width = "300px";
    sidebar.style.right = "0px";
    sidebar.style.top = "auto";

    // Animation fluide pour l'opacité
    setTimeout(() => {
      sidebar.style.transition = "opacity 0.3s ease-in-out, width 0.3s ease-in-out";
      sidebar.style.opacity = "1";
    }, 10);
  }

  closeNav(sidebar) {
    this.isOpened = false; // Indique que le sidebar est fermé
    sidebar.style.opacity = "0"; // Ajoute un fondu progressif
    sidebar.style.transition = "opacity 0.3s ease-in-out, width 0.3s ease-in-out";

    setTimeout(() => {
      sidebar.style.width = "0px";
    }, 50); // Légère attente pour commencer la réduction de largeur

    setTimeout(() => {
      sidebar.style.display = "none"; // Cache après l'animation
    }, 300);
  }

  closeOnClickOutside(event) {
    if (this.isOpened && this.sidebar && !this.sidebar.contains(event.target) && !event.target.closest(".toggle-sidebar-btn")) {
      this.closeNav(this.sidebar);
    }
  }

  closeOnEscape(event) {
    if (this.isOpened && event.key === "Escape" && this.sidebar) {
      this.closeNav(this.sidebar);
    }
  }
}
